// eslint-disable-next-line @nx/enforce-module-boundaries
import { verticals } from '../../../rates-research-api/src/schemas/rate-sets-schema'
import { forEach } from 'lodash'
import { useStoreActions } from '../store'

const uiVerticals = [{ id: 'all_loans', name: 'All Loans' }]
let v = []

export const GetVerticals = (returnUiVerticals: boolean) => {
  const isStaff = useStoreActions(actions => actions.auth).userHasRole('staff')

  if (isStaff) {
    if (returnUiVerticals) {
      // add UI verticals
      v = Object.assign([], verticals)
      forEach(uiVerticals, uiVertical => {
        v[v.length] = { id: uiVertical.id, name: uiVertical.name }
      })
    } else {
      v = verticals
    }
  } else {
    // non-admin users should not see the credit cards vertical
    v = verticals.filter(vertical => vertical.id !== 'credit-cards')
  }

  return v.sort((a, b) => a.name.localeCompare(b.name))
}

export const getLastTouchedVertical = (returnUiVerticals: boolean) => {
  const lastVertical = localStorage.getItem('lastVertical')
  // Note - if you switch users with different permissions the last vertical may be a value you should not see,
  // purposefully not checking for this since it's an edge case and when you click a new vertical the issue is resolved
  return !lastVertical || (!returnUiVerticals && isUiVertical(lastVertical))
    ? null
    : lastVertical
}

export const saveLastTouchedVertical = (vertical: string) =>
  localStorage.setItem('lastVertical', vertical)

const isUiVertical = (vertical: string) => {
  return uiVerticals.map(v => v.id).includes(vertical)
}
